import styled from 'styled-components';

import Avatar from '@material-ui/core/Avatar';

export const StyledAvatar = styled(Avatar)`
    ${({ theme, $avatarSize, $borderRadius, $backgroundColor, onClick, deactivate, disabled }) => `
   width: ${$avatarSize ? $avatarSize : '100%'};
   height: ${$avatarSize ? $avatarSize : '100%'};
   max-width: 120px;
   max-height: 120px;
   border-radius: ${$borderRadius ? $borderRadius : '16px'};
   text-transform: uppercase;
   background-color: ${theme.palette.common[$backgroundColor]};
   color: ${theme.palette.common.white};
   cursor: ${disabled ? 'not-allowed' : onClick ? 'pointer' : 'default'};
   opacity: ${deactivate || disabled ? '0.6' : '1'};
   z-index: auto !important;
   `}
`;
